export default __webpack_public_path__ + "static/video-6fb944cfb521153382f008dc5927fcc9.mp4";